(function () {
function $031feada4a3b44c2$export$2c579a9f1ddaf08d() {
    const dataToolTips = document.querySelectorAll("[data-tooltip-top], [data-tooltip-right], [data-tooltip-bottom], [data-tooltip-left]");
    dataToolTips.forEach((dataTooltip)=>{
        if (dataTooltip.firstChild.className === "tooltip") return;
        const tooltipText = `<span class="tooltip">${dataTooltip.dataset.tooltipTop ? dataTooltip.dataset.tooltipTop : dataTooltip.dataset.tooltipRight ? dataTooltip.dataset.tooltipRight : dataTooltip.dataset.tooltipBottom ? dataTooltip.dataset.tooltipBottom : dataTooltip.dataset.tooltipLeft}</span>`;
        dataTooltip.insertAdjacentHTML("afterbegin", tooltipText);
    });
    const toolTipsClick = document.querySelectorAll("[data-tooltip-copy]");
    toolTipsClick.forEach((toolTipClick)=>{
        toolTipClick.addEventListener("click", function() {
            const tooltip = toolTipClick.querySelector(".tooltip");
            tooltip.textContent = toolTipClick.dataset.tooltipCopy;
            setTimeout(()=>{
                tooltip.textContent = toolTipClick.dataset.tooltipTop ? toolTipClick.dataset.tooltipTop : toolTipClick.dataset.tooltipRight ? toolTipClick.dataset.tooltipRight : toolTipClick.dataset.tooltipBottom ? toolTipClick.dataset.tooltipBottom : toolTipClick.dataset.tooltipLeft;
            }, 1000);
        });
    });
}
document.addEventListener("DOMContentLoaded", $031feada4a3b44c2$export$2c579a9f1ddaf08d);


document.addEventListener("click", (e)=>{
    // Add class ac-body and hidden to dropdowns
    const accordionBodies = document.querySelectorAll(".ac-body");
    accordionBodies.forEach(function(accordionBody) {
        const accordionHeader = accordionBody.previousElementSibling;
        if (e.target !== accordionBody && e.target !== accordionHeader && !accordionBody.contains(e.target)) {
            accordionHeader.classList.toggle("active");
            accordionBody.classList.toggle("!block");
        }
    });
    // Add class ac-header to the button that opens the dropdown
    if (e.target.classList.contains("ac-header")) {
        const accordionBody = e.target.nextElementSibling;
        const accordionHeader = e.target;
        accordionHeader.classList.toggle("active");
        accordionBody.classList.toggle("!block");
    }
    if (e.target.classList.contains("ac-footer")) {
        const accordionBody = e.target.previousElementSibling;
        const accordionHeader = e.target;
        accordionHeader.classList.toggle("active");
        accordionBody.classList.toggle("!block");
    }
    if (e.target.classList.contains("ac-open-bottom")) {
        const accordionBody = e.target.nextElementSibling;
        const accordionHeader = e.target;
        accordionHeader.classList.toggle("active");
        if (!accordionBody.classList.contains("!flex")) accordionBody.classList.add("!flex", "gap-3", "top-full", "p-1", "bg-white", "rounded");
        else accordionBody.classList.remove("!flex", "gap-3", "top-full", "p-1", "bg-white", "rounded");
    }
    if (e.target.classList.contains("overlay")) {
        const overlay = e.target;
        overlay.classList.remove("visible");
    }
});


document.addEventListener("click", (e)=>{
    if (e.target.classList.contains("tab")) {
        const tab = e.target;
        const tabs = document.querySelectorAll(".tab");
        const tabContents = document.querySelectorAll(".tab-content");
        tabs.forEach((tab)=>{
            tab.classList.remove("active");
        });
        tab.classList.add("active");
        tabContents.forEach((tabContent)=>{
            tabContent.classList.remove("active");
            if (tabContent.dataset.tab === tab.dataset.tab) tabContent.classList.add("active");
        });
    }
});


document.addEventListener("click", (e)=>{
    if (e.target.matches("a")) {
        let href = e.target.getAttribute("href");
        if (!href.startsWith("#") || href.startsWith("#") && href.length < 2) return;
        e.preventDefault();
        let target = document.querySelector(href);
        if (!target) return;
        let headerOffset = 130;
        let elementPosition = target.offsetTop;
        let offsetPosition = elementPosition - headerOffset;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }
});


let $9aa4113698f7fa9e$var$paged = 1;
const $9aa4113698f7fa9e$export$b10b9b608ed3fa77 = async (e)=>{
    let postContainer, loadMoreBtn = e.target, loadMoreBtnText = loadMoreBtn.querySelector(".load-more-text"), excludePosts = [
        ...document.querySelectorAll("[data-post-id]")
    ].map((exP)=>exP.dataset.postId);
    const data = new FormData();
    const articleListing = loadMoreBtn.closest(".container");
    postContainer = articleListing.querySelector(".post-listing");
    if (loadMoreBtn.dataset.catId) data.append("cat_id", loadMoreBtn.dataset.catId);
    if (loadMoreBtn.dataset.searchQuery) data.append("search_query", loadMoreBtn.dataset.searchQuery);
    loadMoreBtn.classList.add("loading");
    $9aa4113698f7fa9e$var$paged++;
    if (excludePosts.length > 0) data.append("exclude", excludePosts);
    if (loadMoreBtn.dataset.postType) data.append("post_type", loadMoreBtn.dataset.postType);
    data.append("card_class", loadMoreBtn.dataset.cardClass);
    data.append("card_body", loadMoreBtn.dataset.cardBody);
    data.append("action", "load_more");
    data.append("security", liGlobal.loadMore);
    data.append("paged", $9aa4113698f7fa9e$var$paged || 1);
    fetch(liGlobal.ajaxUrl, {
        method: "POST",
        body: data
    }).then((response)=>response.text()).then((response)=>{
        response = JSON.parse(response);
        if (!response.success) return;
        if (response.data.load_more_btn_text === "Inga fler inl\xe4gg") {
            loadMoreBtn.setAttribute("disabled", "disabled");
            loadMoreBtn.classList.remove("loading");
        } else loadMoreBtn.removeAttribute("disabled");
        loadMoreBtnText.textContent = response.data.load_more_btn_text;
        loadMoreBtn.classList.remove("loading");
        const posts = response.data.posts;
        posts.forEach((post)=>{
            postContainer.insertAdjacentHTML("beforeend", post);
        });
    // postCount.textContent = response.data.found_posts
    }).catch((error)=>{
        console.error("error " + error);
    });
};
document.addEventListener("click", function(e) {
    if (e.target.classList.contains("load-more")) {
        e.preventDefault();
        $9aa4113698f7fa9e$export$b10b9b608ed3fa77(e);
    }
});


/**
 *  Add data-toggle_modal="my-modal-id" to a button
 *  Add data-modal_id="my-modal-id" to an element
 *  An inner div is required in the modal element, see example below
 **/ let $c34fafc86f04ace2$var$modal, $c34fafc86f04ace2$var$overlay, $c34fafc86f04ace2$var$modalId, $c34fafc86f04ace2$var$closeBtn;
document.addEventListener("click", (e)=>{
    if (e.target.dataset.toggle_modal) {
        if ($c34fafc86f04ace2$var$modal && $c34fafc86f04ace2$var$modal.classList.contains("active")) {
            $c34fafc86f04ace2$var$modal.classList.remove("active");
            $c34fafc86f04ace2$var$modal.querySelector(".overlay").remove();
            $c34fafc86f04ace2$var$modal.querySelector(".close-btn").remove();
        } else {
            $c34fafc86f04ace2$var$modalId = e.target.dataset.toggle_modal;
            $c34fafc86f04ace2$var$modal = document.querySelector([
                `[data-modal_id="${$c34fafc86f04ace2$var$modalId}"]`
            ]);
            let modalBody;
            modalBody = $c34fafc86f04ace2$var$modal.querySelector("div:last-child");
            if (!modalBody) modalBody = $c34fafc86f04ace2$var$modal.querySelector("nav:last-child");
            $c34fafc86f04ace2$var$overlay = /*html*/ `<div class="overlay fixed inset-0 bg-black/25" data-toggle_modal="${$c34fafc86f04ace2$var$modalId}"></div>`;
            $c34fafc86f04ace2$var$closeBtn = /*html*/ `<button class="close-btn absolute flex items-center justify-center size-10 duration-150 rounded-full right-3 bg-black/5 lg:hover:bg-black/10 backdrop-blur-sm active:bg-black/15 top-3" data-toggle_modal="${$c34fafc86f04ace2$var$modalId}">
                <span class="material-icons-round text-black">close</span>
            </button>`;
            modalBody.insertAdjacentHTML("afterbegin", $c34fafc86f04ace2$var$closeBtn);
            $c34fafc86f04ace2$var$modal.insertAdjacentHTML("afterbegin", $c34fafc86f04ace2$var$overlay);
            $c34fafc86f04ace2$var$modal.classList.toggle("active");
        }
    }
}) /**
 * 
 * Example:
 * 
<button data-toggle_modal="login">Logga in</button>

<div class="flex items-center justify-center" data-modal_id="login">
    <div class="relative z-10 w-full max-w-lg p-4 bg-white rounded-lg md:p-6 lg:p-8">

    </div>
</div>
*/ ;


// Funktion för att sätta en cookie
const $7be597f098f5dfd6$var$setCookie = (name, value, days)=>{
    const expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = `${name}=${value};expires=${expires};path=/`;
};
// Funktion för att hämta en cookie
const $7be597f098f5dfd6$var$getCookie = (name)=>{
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
};
// Sätter en cookie om användaren redan sett popupen och stängt den
const $7be597f098f5dfd6$var$setPopupCookie = ()=>{
    $7be597f098f5dfd6$var$setCookie("li_popup", "closed", document.querySelector(".li-popup").getAttribute("data-popup_setcookie"));
};
// Kollar om användaren redan sett och stängt popupen
const $7be597f098f5dfd6$var$checkPopupCookie = ()=>{
    return $7be597f098f5dfd6$var$getCookie("li_popup") !== "closed";
};
// Stänger popupen
const $7be597f098f5dfd6$var$closePopup = ()=>{
    const popup = document.querySelector(".li-popup");
    popup.classList.remove("active");
    $7be597f098f5dfd6$var$setPopupCookie();
};
// Öppnar popupen om användaren inte redan sett den efter 5 sekunder
const $7be597f098f5dfd6$var$openPopup = ()=>{
    const popup = document.querySelector(".li-popup");
    if (!popup) return;
    const delay = popup.dataset.popup_delay * 1000;
    setTimeout(()=>{
        if ($7be597f098f5dfd6$var$checkPopupCookie()) popup.classList.add("active");
    }, delay);
};
// Stänger popupen på stängknappen
const $7be597f098f5dfd6$var$closePopupBtn = ()=>{
    const closeBtn = document.querySelector(".close-li-popup");
    if (!closeBtn) return;
    closeBtn.addEventListener("click", $7be597f098f5dfd6$var$closePopup);
};
// Stänger popupen om användaren klickar utanför
const $7be597f098f5dfd6$var$closePopupOutside = ()=>{
    const popup = document.querySelector(".li-popup");
    if (!popup) return;
    popup.addEventListener("click", (e)=>{
        if (e.target.classList.contains("li-popup")) $7be597f098f5dfd6$var$closePopup();
    });
};
// Initialize the popup
const $7be597f098f5dfd6$var$initPopup = ()=>{
    $7be597f098f5dfd6$var$openPopup();
    $7be597f098f5dfd6$var$closePopupBtn();
    $7be597f098f5dfd6$var$closePopupOutside();
};
document.addEventListener("DOMContentLoaded", $7be597f098f5dfd6$var$initPopup);


let $ae7d283db5dd77fd$var$vimeoOptions = {
    playsinline: true,
    background: true
};
let $ae7d283db5dd77fd$var$videoWrapper, $ae7d283db5dd77fd$var$player, $ae7d283db5dd77fd$var$videoId, $ae7d283db5dd77fd$var$videoType, $ae7d283db5dd77fd$var$checkViewPort, $ae7d283db5dd77fd$var$controls, $ae7d283db5dd77fd$var$autoplay;
function $ae7d283db5dd77fd$var$initPlayers() {
    $ae7d283db5dd77fd$var$videoWrapper = document.querySelectorAll(".video-player-wrapper");
    if ($ae7d283db5dd77fd$var$videoWrapper.length === 0) return;
    $ae7d283db5dd77fd$var$videoWrapper.forEach(function(wrapper) {
        let options, video;
        $ae7d283db5dd77fd$var$player = wrapper.querySelector(".video-player");
        $ae7d283db5dd77fd$var$videoId = wrapper.getAttribute("data-video-id");
        $ae7d283db5dd77fd$var$videoType = wrapper.getAttribute("data-video-type");
        $ae7d283db5dd77fd$var$checkViewPort = wrapper.getAttribute("data-video-check-viewport");
        $ae7d283db5dd77fd$var$controls = wrapper.getAttribute("data-video-controls");
        $ae7d283db5dd77fd$var$autoplay = wrapper.getAttribute("data-video-autoplay");
        if ($ae7d283db5dd77fd$var$videoType === "html5") video = $ae7d283db5dd77fd$var$player.querySelector("video");
        if ($ae7d283db5dd77fd$var$videoType === "vimeo") {
            options = $ae7d283db5dd77fd$var$vimeoOptions;
            options.id = $ae7d283db5dd77fd$var$videoId;
            if ($ae7d283db5dd77fd$var$controls === "1") {
                options.background = false;
                options.controls = true;
            }
            if ($ae7d283db5dd77fd$var$autoplay !== "1") {
                options.background = false;
                options.playsinline = false;
                options.autoplay = false;
                options.controls = false;
            }
            video = new Vimeo.Player($ae7d283db5dd77fd$var$player, options);
        }
        // check if player is in viewport on load
        if ($ae7d283db5dd77fd$var$checkViewPort === "1") {
            if ($ae7d283db5dd77fd$var$isInViewport(wrapper)) {
                if ($ae7d283db5dd77fd$var$videoType === "vimeo" || $ae7d283db5dd77fd$var$videoType === "html5") video.play();
            } else if ($ae7d283db5dd77fd$var$videoType === "vimeo" || $ae7d283db5dd77fd$var$videoType === "html5") video.pause();
        }
    });
}
document.addEventListener("DOMContentLoaded", $ae7d283db5dd77fd$var$initPlayers);
window.addEventListener("scroll", $ae7d283db5dd77fd$var$initPlayers);
// check if player is in viewport
function $ae7d283db5dd77fd$var$isInViewport(elem) {
    var bounding = elem.getBoundingClientRect();
    return bounding.top >= -100 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight + 100 || document.documentElement.clientHeight + 100) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
}


const $dd269c43bb3cf205$var$siteHeader = document.querySelector(".site-header");
// Check if window is scrolled by at least 8x
const $dd269c43bb3cf205$var$scrollCheck = ()=>{
    if (document.documentElement.classList.contains("stay-dark")) return;
    if (window.scrollY > 8) // add class to html element
    document.documentElement.classList.add("dark");
    else document.documentElement.classList.remove("dark");
};
// Listen for scroll events
window.addEventListener("scroll", $dd269c43bb3cf205$var$scrollCheck);
// Run scrollCheck on load
$dd269c43bb3cf205$var$scrollCheck();


const $d9bbb5e2b12cf194$var$mainMenu = document.querySelector("#main-menu");
const $d9bbb5e2b12cf194$var$menuToggleBtn = document.querySelector(".main-menu-toggle-btn");
const $d9bbb5e2b12cf194$var$searchWrapper = document.querySelector(".site-search-wrapper");
const $d9bbb5e2b12cf194$var$searchInput = $d9bbb5e2b12cf194$var$searchWrapper.querySelector(".main-search-input");
function $d9bbb5e2b12cf194$var$toggleMenu() {
    $d9bbb5e2b12cf194$var$closeSearch();
    $d9bbb5e2b12cf194$var$mainMenu.classList.toggle("!flex");
    $d9bbb5e2b12cf194$var$menuToggleBtn.classList.contains("menu-toggled") ? $d9bbb5e2b12cf194$var$menuToggleBtn.classList.remove("menu-toggled") : $d9bbb5e2b12cf194$var$menuToggleBtn.classList.add("menu-toggled");
}
let $d9bbb5e2b12cf194$var$dropdownBtn, $d9bbb5e2b12cf194$var$dropdown;
document.addEventListener("click", function(e) {
    if (e.target.closest(".main-menu-toggle-btn")) $d9bbb5e2b12cf194$var$toggleMenu();
    // if clicking outside of dropdown menu and dropdown menu is open then close it
    if ($d9bbb5e2b12cf194$var$dropdown && e.target !== $d9bbb5e2b12cf194$var$dropdown && !$d9bbb5e2b12cf194$var$dropdown.contains(e.target)) {
        $d9bbb5e2b12cf194$var$dropdownBtn.classList.remove("pointer-events-none");
        $d9bbb5e2b12cf194$var$dropdown.classList.remove("!block");
    }
    if (e.target.classList.contains("dropdown-btn")) {
        $d9bbb5e2b12cf194$var$dropdownBtn = e.target;
        $d9bbb5e2b12cf194$var$mainMenu.classList.remove("!flex");
        $d9bbb5e2b12cf194$var$menuToggleBtn.classList.remove("menu-toggled");
        $d9bbb5e2b12cf194$var$dropdown = e.target.closest(".dropdown-btn").nextElementSibling;
        if ($d9bbb5e2b12cf194$var$dropdown.classList.contains("!block")) $d9bbb5e2b12cf194$var$dropdown.classList.remove("!block");
        else {
            $d9bbb5e2b12cf194$var$dropdownBtn.classList.add("pointer-events-none");
            $d9bbb5e2b12cf194$var$dropdown.classList.add("!block");
        }
    }
    if (e.target.classList.contains("sub-menu-toggle-button")) {
        const parent = e.target.closest(".menu-item-has-children");
        const submenu = parent.querySelector(".sub-menu");
        if (submenu.classList.contains("active")) {
            submenu.classList.remove("active");
            parent.classList.remove("active");
        } else {
            submenu.classList.add("active");
            parent.classList.add("active");
        }
    }
    // Search toggle
    if (e.target.classList.contains("search-toggle")) {
        $d9bbb5e2b12cf194$var$searchWrapper.classList.toggle("!block");
        $d9bbb5e2b12cf194$var$mainMenu.classList.remove("!flex");
        $d9bbb5e2b12cf194$var$menuToggleBtn.classList.remove("menu-toggled");
        $d9bbb5e2b12cf194$var$searchInput.focus();
    }
    if (e.target.classList.contains("search-overlay") || e.target.classList.contains("close-search")) $d9bbb5e2b12cf194$var$closeSearch();
});
// remove submenu_classes from submenu when window is resized, only once
const $d9bbb5e2b12cf194$var$submenus = document.querySelectorAll(".sub-menu");
let $d9bbb5e2b12cf194$var$resized = false;
window.addEventListener("resize", function() {
    if (window.innerWidth > 1024) {
        if ($d9bbb5e2b12cf194$var$resized) return;
        $d9bbb5e2b12cf194$var$submenus.forEach((submenu)=>submenu.classList.remove("active"));
        $d9bbb5e2b12cf194$var$resized = true;
    } else {
        if (!$d9bbb5e2b12cf194$var$resized) return;
        $d9bbb5e2b12cf194$var$submenus.forEach((submenu)=>submenu.classList.remove("active"));
        $d9bbb5e2b12cf194$var$resized = false;
    }
});
function $d9bbb5e2b12cf194$var$closeSearch() {
    $d9bbb5e2b12cf194$var$searchInput.value = "";
    $d9bbb5e2b12cf194$var$searchWrapper.classList.remove("!block");
    return;
}
document.addEventListener("keyup", function(e) {
    if (e.target.classList.contains("main-search-input")) {
        if (e.key === "Escape") $d9bbb5e2b12cf194$var$closeSearch();
    }
});


document.addEventListener("click", (e)=>{
    if (e.target.classList.contains("expand-nav")) {
        const asideNavContainer = document.querySelector("#aside-nav-container");
        const asideNav = asideNavContainer.querySelector("nav");
        if (!asideNavContainer.classList.contains("expanded")) {
            const top = asideNav.getBoundingClientRect().top;
            const left = asideNav.getBoundingClientRect().left;
            const width = asideNavContainer.getBoundingClientRect().width;
            asideNav.style.top = `${top}px`;
            asideNav.style.left = `${left}px`;
            asideNav.style.width = `${width}px`;
            asideNavContainer.classList.add("expanded");
        } else {
            asideNav.style.top = `0px`;
            asideNav.style.left = `0px`;
            asideNav.style.width = `100%`;
            asideNavContainer.classList.remove("expanded");
        }
    }
});
function $feea46c0bad4a696$var$handleAsideNav() {
    const asideNavContainer = document.querySelector("#aside-nav-container");
    if (!asideNavContainer) return;
    const asideNav = asideNavContainer.querySelector("nav");
    if (window.innerWidth > 640) {
        if (asideNavContainer.classList.contains("expanded")) {
            const top = asideNavContainer.getBoundingClientRect().top;
            const left = asideNavContainer.getBoundingClientRect().left;
            const width = asideNavContainer.getBoundingClientRect().width;
            asideNav.style.top = `${top}px`;
            asideNav.style.left = `${left}px`;
            asideNav.style.width = `${width}px`;
        }
    }
    if (window.innerWidth < 640) asideNavContainer.setAttribute("data-modal_id", "aside-nav");
    else asideNavContainer.removeAttribute("data-modal_id");
}
document.addEventListener("DOMContentLoaded", $feea46c0bad4a696$var$handleAsideNav);
window.addEventListener("resize", $feea46c0bad4a696$var$handleAsideNav);
window.addEventListener("scroll", (e)=>{
    const asideNavBtn = document.querySelector('[data-toggle_modal="aside-nav"]');
    if (!asideNavBtn) return;
    const asideNavBtnTop = asideNavBtn.parentElement.getBoundingClientRect().top;
    // Check if the button is 60px from the top of the viewport
    if (asideNavBtnTop < 68) asideNavBtn.classList.add("fixed");
    else asideNavBtn.classList.remove("fixed");
});


const $c001ddf96774b03f$export$becb836e43488847 = ()=>{
    // Target all input containers from all Gravity Forms
    const inputContainers = document.getElementsByClassName("ginput_container");
    if (inputContainers.length) // Setup focus and blur events for each field
    for (const inputContainer of inputContainers){
        // Target input element in container, whether it's an input or a textarea
        const inputElement = inputContainer.querySelectorAll(":scope > *")[0];
        // Label element is always the previous sibling of the input container
        const labelElement = inputContainer.previousElementSibling;
        // Activate label if input has value - this moves the label above the input
        inputElement.addEventListener("focus", (event)=>{
            labelElement.classList.add("active");
        });
        // Deactivate label if input is empty on blur - this moves the label back to its original position
        inputElement.addEventListener("blur", (event)=>{
            if (inputElement.value === "") labelElement.classList.remove("active");
        });
        // If the input has a value on page load (when user submit fails) then activate the label
        // Also prevent animation to avoid flicker
        if (inputElement.value !== "") {
            labelElement.classList.add("no-animation");
            labelElement.classList.add("active");
            setTimeout(()=>{
                labelElement.classList.remove("no-animation");
            }, 200);
        }
    }
};
document.addEventListener("DOMContentLoaded", function() {
    // Have to use jQuery here because the gform_post_render event is triggered by Gravity Forms
    // This fires on page load and on submit.
    jQuery(document).on("gform_post_render", function(event, form_id, current_page) {
        // Move validation error message to bottom of form
        jQuery("div.gform_validation_errors").appendTo("div.gform_body");
        $c001ddf96774b03f$export$becb836e43488847();
    });
}, false);


document.addEventListener("click", function(e) {
    if (e.target.closest(".toggle-coworker-info")) {
        if (e.target.closest(".coworker-card").classList.contains("active")) e.target.closest(".coworker-card").classList.remove("active");
        else e.target.closest(".coworker-card").classList.add("active");
    }
});


document.addEventListener("click", (e)=>{
    if (e.target.closest(".cat-filter")) {
        const catFilters = document.querySelectorAll(".cat-filter");
        catFilters.forEach((catFilter)=>catFilter.classList.remove("active"));
        const catFilter = e.target.closest(".cat-filter");
        const filterValue = catFilter.dataset.value;
        const postListing = catFilter.closest(".pc-post-listing");
        const postContainer = postListing.querySelector(".post-listing");
        const loadMoreBtn = postListing.querySelector(".load-more");
        if (loadMoreBtn) {
            loadMoreBtnText = loadMoreBtn.querySelector(".load-more-text");
            loadMoreBtn.dataset.catId = filterValue;
        }
        const data = new FormData();
        data.append("action", "load_more");
        data.append("security", liGlobal.loadMore);
        data.append("cat_id", filterValue);
        data.append("post_type", "post");
        if (loadMoreBtn) {
            data.append("card_class", loadMoreBtn.dataset.cardClass);
            data.append("card_body", loadMoreBtn.dataset.cardBody);
        }
        fetch(liGlobal.ajaxUrl, {
            method: "POST",
            body: data
        }).then((response)=>response.text()).then((response)=>{
            response = JSON.parse(response);
            if (!response.success) return;
            catFilter.classList.add("active");
            if (loadMoreBtn) {
                if (response.data.load_more_btn_text === "Inga fler inl\xe4gg") {
                    loadMoreBtn.setAttribute("disabled", "disabled");
                    loadMoreBtn.classList.remove("loading");
                } else loadMoreBtn.removeAttribute("disabled");
                loadMoreBtnText.textContent = response.data.load_more_btn_text;
            }
            const posts = response.data.posts;
            postContainer.innerHTML = "";
            posts.forEach((post)=>{
                postContainer.insertAdjacentHTML("beforeend", post);
            });
        });
    }
});



if (null) null.accept();

})();
//# sourceMappingURL=app.js.map
